import { render, staticRenderFns } from "./BaseCircularPreloader.vue?vue&type=template&id=5f61c52e"
import script from "./BaseCircularPreloader.vue?vue&type=script&lang=ts"
export * from "./BaseCircularPreloader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports